import { render, staticRenderFns } from "./RButton.vue?vue&type=template&id=1f250340&scoped=true"
import script from "./RButton.vue?vue&type=script&lang=js"
export * from "./RButton.vue?vue&type=script&lang=js"
import style0 from "./RButton.vue?vue&type=style&index=0&id=1f250340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f250340",
  null
  
)

export default component.exports